class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        
        setTimeout(() => {
          FacetFiltersForm.updateSelectedCount();
        }, 100);

        FacetFiltersForm.updateSelectedCount();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        loadmoreinfinity();
        sortByCollection();
      });
  }

  static updateSelectedCount() {
    document.querySelectorAll('.single_tab').forEach(tab => {
      var tabTitle = tab.querySelector('.tab_title')?.innerText.trim(),
          selectedCount = 0;
      if(!tabTitle) return;

      document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked').forEach(input => {
        var filterContainer = input.closest('.single_tab_data');
        if(!filterContainer) return;

        var filterTitle = filterContainer.querySelector('.filter_label')?.innerText.trim();
        if(filterTitle === tabTitle){
          selectedCount++;
        }
      });

      var countElement = tab.querySelector('.selected_count');
      if(countElement){
        countElement.innerHTML = selectedCount > 0 ? `${selectedCount} selected` : '';
      }
    });
  }

  static updateFooterButtonsState() {
    const footer = document.querySelector('.mobile-facets__footer.js_filter');
    if (!footer) return;

    const clearBtn = footer.querySelector('.mobile-facets__clear');
    const applyBtn = footer.querySelector('button.button--primary');
    let isActive = false;

    const anyCheckboxChecked = document.querySelector('#FacetFiltersFormMobile input[type="checkbox"]:checked');
    if (anyCheckboxChecked) {
      isActive = true;
    }

    const textInputs = document.querySelectorAll('#FacetFiltersFormMobile price-range input[type="text"]');
    const rangeInputs = document.querySelectorAll('#FacetFiltersFormMobile price-range input[type="range"]');
    
    if (textInputs.length >= 2 && rangeInputs.length >= 2) {
      const minPriceInput = textInputs[0];
      const maxPriceInput = textInputs[1];
      const maxSlider = rangeInputs[1];
      const minVal = parseFloat((minPriceInput.value || '0').replace(/,/g, ''));
      const maxVal = parseFloat((maxPriceInput.value || '0').replace(/,/g, ''));
      const defaultMax = parseFloat((maxSlider.max || '0').replace(/,/g, ''));
      
      if (minVal > 0 || (maxVal > 0 && maxVal < defaultMax)) {
        isActive = true;
      }
    }

    if (isActive) {
      if(clearBtn) {
          clearBtn.classList.remove('disabled');
      }
      if(applyBtn) {
          applyBtn.classList.remove('disabled');
          applyBtn.removeAttribute('disabled');
      }
    } else {
      if(clearBtn) {
          clearBtn.classList.add('disabled');
      }
      if(applyBtn) {
          applyBtn.classList.add('disabled');
          applyBtn.setAttribute('disabled', 'true');
      }
    }
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    setTimeout(() => {
      FacetFiltersForm.updateSelectedCount();
    },100);

    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (window.initLazyImages) {
      window.initLazyImages();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const currentUrlParams = new URLSearchParams(window.location.search);
    const layout = currentUrlParams.get('layout');
    const image = currentUrlParams.get('image');
    const newParams = new URLSearchParams(searchParams);

    if (layout !== null && image !== null) {
      newParams.set('layout', layout);
      newParams.set('image', image);
    }
    
    const finalParamsString = newParams.toString();
    const newUrl = `${window.location.pathname}${finalParamsString ? '?' + finalParamsString : ''}`;

    history.pushState({ searchParams: finalParamsString }, '', newUrl);

    // history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input').forEach((element) => {
//       element.addEventListener('change', this.onRangeChange.bind(this));
//       element.addEventListener('keydown', this.onKeyDown.bind(this));
//     });
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   onKeyDown(event) {
//     if (event.metaKey) return;

//     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
//     if (!event.key.match(pattern)) event.preventDefault();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
//     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('data-min'));
//     const max = Number(input.getAttribute('data-max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.textInputs = this.querySelectorAll('input[type="text"]');
    this.rangeInputs = this.querySelectorAll('input[type="range"]');
    this.sliderTrack = this.querySelector('.slider-track');

    this.textInputs.forEach((input) => {
      input.addEventListener('change', this.onRangeChange.bind(this));
      input.addEventListener('keydown', this.onKeyDown.bind(this));

      input.addEventListener('focus', function() {
        if (this.value === '0') {
          this.value = '';
        }
      });

      input.addEventListener('blur', function() {
        if (this.value === '') {
          this.value = '0';
        }
      });
      
    });

    this.rangeInputs.forEach((input) => {
      input.addEventListener('input', this.onSliderInput.bind(this));
    });

    // this.syncSliderFromTextInputs();
    // this.updateSliderTrack();
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.initializeSlider();
      });
    });
  }

  initializeSlider() {
    const [minInput, maxInput] = this.textInputs;
    const [minRange, maxRange] = this.rangeInputs;

    const cleanMin = parseInt((minInput.value || '0').replace(/,/g, ''));
    const cleanMax = parseInt((maxInput.value || '').replace(/,/g, ''));

    minRange.value = !isNaN(cleanMin) ? cleanMin : 0;
    maxRange.value = !isNaN(cleanMax)
      ? cleanMax
      : parseInt(maxRange.max);

    this.correctCrossover();
    this.updateSliderTrack();
    FacetFiltersForm.updateFooterButtonsState();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.syncSliderFromTextInputs();
    this.correctCrossover();
    this.updateSliderTrack();
    FacetFiltersForm.updateFooterButtonsState();
  }

  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /^[0-9.,\b\t\s]|Arrow(Up|Down|Left|Right)|Backspace|Enter|Delete|Escape$/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  onSliderInput() {
    this.correctCrossover();
    this.syncTextInputsFromSlider();
    this.updateSliderTrack();
    FacetFiltersForm.updateFooterButtonsState();
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('max')) || Number(input.getAttribute('data-max')) || 999999;
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  correctCrossover() {
    const [minRange, maxRange] = this.rangeInputs;
    let minVal = parseInt(minRange.value);
    let maxVal = parseInt(maxRange.value);

    if (minVal > maxVal) {
      [minRange.value, maxRange.value] = [maxVal, minVal];
    }

    const [minInput, maxInput] = this.textInputs;
    minInput.value = minRange.value;
    maxInput.value = maxRange.value;
  }

  syncTextInputsFromSlider() {
    const [minRange, maxRange] = this.rangeInputs;
    const [minInput, maxInput] = this.textInputs;

    minInput.value = minRange.value;
    maxInput.value = maxRange.value;
  }

  syncSliderFromTextInputs() {
    const [minInput, maxInput] = this.textInputs;
    const [minRange, maxRange] = this.rangeInputs;

    minRange.value = parseInt(minInput.value) || 0;
    maxRange.value = parseInt(maxInput.value) || maxRange.max;
  }

  updateSliderTrack() {
    if (!this.sliderTrack) return;

    const [minRange, maxRange] = this.rangeInputs;
    const rangeMin = parseFloat(minRange.min) || 0;
    const rangeMax = parseFloat(maxRange.max) || 100;

    const minVal = parseFloat(minRange.value);
    const maxVal = parseFloat(maxRange.value);

    const percent1 = ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100;
    const percent2 = ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100;
    
    this.sliderTrack.style.left = `${percent1}%`;
    this.sliderTrack.style.right = `${100 - percent2}%`;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('change', function(e){
   if(e.target.matches('input[type="checkbox"]')){
      FacetFiltersForm.updateSelectedCount();
      FacetFiltersForm.updateFooterButtonsState();
   }
});

document.addEventListener('DOMContentLoaded', function(){
   FacetFiltersForm.updateSelectedCount();
   FacetFiltersForm.updateFooterButtonsState();
});

document.addEventListener("click", function(e){
  var single_tab = e.target.closest(".filter_tab_inner .tab_control .single_tab");

  if(!single_tab) return;

  var data_tab = single_tab.getAttribute("data_tab"),
      wrapper = single_tab.closest(".filter_tab_inner");

  wrapper.querySelectorAll(".single_tab").forEach(function(item){
      item.classList.remove("active");
  });

  single_tab.classList.add("active");

  wrapper.querySelectorAll(".single_tab_data").forEach(function(item){
      item.classList.add("hidden");
  });

  var targetTab = wrapper.querySelector(`.single_tab_data[data_tab="${data_tab}"]`);

  if(targetTab){
      targetTab.classList.remove("hidden");
  }
});
   
document.addEventListener("click", function(e){
  var drawerTab = e.target.closest(".drawer_single_tab");
  if(!drawerTab) return;
  
  var dataTab = drawerTab.getAttribute("data_tab"),
      drawerSummary = document.querySelector(".mobile-facets__wrapper summary"),
      drawerDetails = document.querySelector(".mobile-facets__wrapper details");

  if(drawerDetails && !drawerDetails.hasAttribute("open")){
      drawerSummary.click();
  }
  var targetTab = document.querySelector(`.single_tab[data_tab="${dataTab}"]`);
  if(!targetTab) return;
  targetTab.click();
});